export const DATE_RANGE_TYPE = {
  RANGE: "RANGE",
  TODAY: "TODAY",
  YESTERDAY: "YESTERDAY",
  THIS_WEEK: "THIS_WEEK",
  LAST_WEEK: "LAST_WEEK",
  THIS_MONTH: "THIS_MONTH",
  LAST_MONTH: "LAST_MONTH",

  LAST_24_HOURS: "LAST_24_HOURS",
  LAST_7_DAYS: "LAST_7_DAYS",
  PREVIOUS_7_DAYS: "PREVIOUS_7_DAYS",
  LAST_30_DAYS: "LAST_30_DAYS",
};

export const mapTypeToAnalyticsType = (type) => {
  switch (type) {
    case DATE_RANGE_TYPE.TODAY:
      return "today";
    case DATE_RANGE_TYPE.YESTERDAY:
      return "yesterday";
    case DATE_RANGE_TYPE.THIS_WEEK:
      return "thisWeek";
    case DATE_RANGE_TYPE.LAST_WEEK:
      return "lastWeek";
    case DATE_RANGE_TYPE.THIS_MONTH:
      return "thisMonth";
    case DATE_RANGE_TYPE.LAST_MONTH:
      return "lastMonth";
    default:
      return "range";
  }
}

export const todayRange = (baseDate) => {
  const startDate = new Date(baseDate);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(baseDate);
  endDate.setHours(23, 59, 59, 999);
  return {
    label: "Today",
    type: DATE_RANGE_TYPE.TODAY,
    startDate,
    endDate,
  };
};

export const yesterdayRange = (baseDate) => {
  const startDate = new Date(baseDate);
  startDate.setDate(startDate.getDate() - 1);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(baseDate);
  endDate.setDate(endDate.getDate() - 1);
  endDate.setHours(23, 59, 59, 999);
  return {
    label: "Yesterday",
    type: DATE_RANGE_TYPE.YESTERDAY,
    startDate,
    endDate,
  };
};

export const thisWeekRange = (baseDate) => {
  const startDate = new Date(baseDate);
  startDate.setDate(startDate.getDate() - (startDate.getDay()+6)%7);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(baseDate);
  endDate.setHours(23, 59, 59, 999);
  return {
    label: "This Week",
    type: DATE_RANGE_TYPE.THIS_WEEK,
    startDate,
    endDate,
  };
};

export const lastWeekRange = (baseDate) => {
  const endDate = new Date(baseDate);
  endDate.setDate(endDate.getDate() - (endDate.getDay()+6)%7 - 1);
  endDate.setHours(23, 59, 59, 999);
  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - 6);
  startDate.setHours(0, 0, 0, 0);
  return {
    label: "Last Week",
    type: DATE_RANGE_TYPE.LAST_WEEK,
    startDate,
    endDate,
  };
};

export const thisMonthRange = (baseDate) => {
  const startDate = new Date(baseDate);
  startDate.setDate(1);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(baseDate);
  endDate.setHours(23, 59, 59, 999);
  return {
    label: "This Month",
    type: DATE_RANGE_TYPE.THIS_MONTH,
    startDate,
    endDate,
  };
};

export const lastMonthRange = (baseDate) => {
  const endDate = new Date(baseDate);
  endDate.setDate(1);
  endDate.setHours(23, 59, 59, 999);
  endDate.setDate(endDate.getDate() - 1);
  const startDate = new Date(endDate);
  startDate.setDate(1);
  startDate.setHours(0, 0, 0, 0);
  return {
    label: "Last Month",
    type: DATE_RANGE_TYPE.LAST_MONTH,
    startDate,
    endDate,
  };
};

export const getDateRanges = () => {
  const today = new Date();
  const result = [
    todayRange(today),
    yesterdayRange(today),
    thisWeekRange(today),
    lastWeekRange(today),
    thisMonthRange(today),
    lastMonthRange(today),
  ];
  result.forEach((e,i) => {
    e.endDate.setTime(e.endDate.getTime() - i); // NOTE: hack to avoid date range overlap
  })
  return result;
};


const MAX_EPOCH_SECONDS = 1e10;

export const parseDate = (rawDate) => {
  if (rawDate instanceof Date) { // already a native date object
    return rawDate;
  } else if (
    typeof rawDate === "number" ||
    (typeof rawDate === "string" && /^\d+$/.test(rawDate)) // a epcoh timestamp
  ) {
    const timestamp =
      typeof rawDate === "number" ? rawDate : parseInt(rawDate, 10);
    if (timestamp < MAX_EPOCH_SECONDS) { // timestamp is in seconds
      return new Date(timestamp * 1000);
    } else { // timestamp is in milliseconds
      return new Date(timestamp);
    }
  } else if (typeof rawDate === "string") { // date string
    if (/^\d{1,2}:\d{1,2}:\d{1,2}$/.test(rawDate)) {
      rawDate = "1970-01-01T" + rawDate + "Z";
    } else if (/^\d{4}-\d{2}-\d{2}$/.test(rawDate)) { // only date
      rawDate = rawDate + "T00:00:00";
    }
    return new Date(rawDate);
  } else {
    console.error(rawDate);
    throw new Error("Unsupported date format");
  }
};

export const DATE_FORMATS = {
    DD_MMMc_YYYY: "DD_MMMc_YYYY", // Example: 25 Jan, 2023
    MMM_DDc_YYYY: "MMM_DDc_YYYY", // Example: Jan 25, 2023
    HHcMM_AP: "HHcMM_AP",         // Example: 2:05 PM
    MMM_YYYY: "MMM_YYYY",         // Example: Jan 2023
    MMM_DDc_YYYY_HHcMM_AP: "MMM_DDc_YYYY_HHcMM_AP", // Example: Jan 25, 2023 2:05 PM
    ISO: "ISO",                  // Example: 2023-01-25T14:05:00.000Z
}

export const formatDate = (date, format) => {
    date = parseDate(date);
    switch (format) {
        case DATE_FORMATS.DD_MMMc_YYYY: {
            const day = date.getDate();
            const month = date.toLocaleString('en-US', { month: 'short' });
            const year = date.getFullYear();
            return `${day} ${month}, ${year}`;
        }
        case DATE_FORMATS.MMM_DDc_YYYY: {
            const month = date.toLocaleString('en-US', { month: 'short' });
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month} ${day}, ${year}`;
        }
        case DATE_FORMATS.HHcMM_AP: {
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const hours12 = hours % 12 || 12;
            return `${hours12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
        }
        case DATE_FORMATS.MMM_YYYY: {
            const month = date.toLocaleString('en-US', {month: 'short'});
            const year = date.getFullYear();
            return `${month} ${year}`;
        }
        case DATE_FORMATS.MMM_DDc_YYYY_HHcMM_AP: {
            const month = date.toLocaleString('en-US', {month: 'short'});
            const day = date.getDate();
            const year = date.getFullYear();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const hours12 = hours % 12 || 12;
            return `${month} ${day}, ${year} ${hours12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
        }
        case DATE_FORMATS.ISO: {
          return date.toISOString();
        }
        default:
            return date.toLocaleString();
    }
}

export const formatAsAgoString = (date) => {
  date = parseDate(date);
  const now = new Date();
  const diff = now.getTime() - date.getTime();

  const diffInSeconds = Math.floor(diff / 1000);
  if (diffInSeconds < 60) {
    return "moments ago";
  }
  
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    const minutes = diffInMinutes === 1 ? "minute" : "minutes";
    return `${diffInMinutes} ${minutes} ago`;
  }
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    const hours = diffInHours === 1 ? "hour" : "hours";
    return `${diffInHours} ${hours} ago`;
  }
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    const days = diffInDays === 1 ? "day" : "days";
    return `${diffInDays} ${days} ago`;
  }
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    const months = diffInMonths === 1 ? "month" : "months";
    return `${diffInMonths} ${months} ago`;
  }
  const diffInYears = Math.floor(diffInMonths / 12);
  const years = diffInYears === 1 ? "year" : "years";
  return `${diffInYears} ${years} ago`;
}
